function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// login footer hide
let loginUrl = "https://dairypill.com/apps/retextion#/login";

let currentUrl = window.location.href;
// console.log("login_url",currentUrl)
if (currentUrl === loginUrl) {
  console.log("Current URL matches the example URL.");
  let footer_div = document.querySelector("footer.footer-div");
  let news = document.querySelector(".newsletter.center");
  // console.log("sfsdg",footer_div)
  footer_div.style.display = "none";
  news.style.display = "none";
} else {
  console.log("Current URL does not match the example URL.");
}

// refill url

// var currentURL = window.location.href;

// var urlParts = currentURL.split("?");

// var baseURL = urlParts[0];

// var queryParams = urlParts[1];

// console.log("Base URL: " + baseURL);
// console.log("Query Parameters: " + queryParams);

var affliatedPage = window.location.href;
if (affliatedPage === "https://dairypill.com/pages/affiliate") {
  var hidedescription = (document.getElementById("img-description").style =
    "display:none");

  // var labelsToHide = [
  //   document.querySelector('label[for="template--21369567248677__eb633112-c64d-42ea-9590-b24afe6123c9-2-0"]'),
  //   document.querySelector('label[for="template--21369567248677__eb633112-c64d-42ea-9590-b24afe6123c9-2-2"]')
  // ];

  // labelsToHide.forEach(function (label) {
  //   if (label) {
  //     label.style.display = "none";
  //   }
  // });
}

var lactoseKit = window.location.href;
if (lactoseKit === "https://dairypill.com/pages/lactose-kit") {
  var hidedescription = (document.getElementById("product_plan").style =
    "display:block");
}

//homepage review section land on pdp
if (
  lactoseKit === "https://dairypill.com/?_ab=0&_fd=0&_sc=1" ||
  lactoseKit === "https://dairypill.com" ||
  lactoseKit === "https://dairypill.com/"
) {
  function delayedClickBinding() {
    var review_div = document.querySelector(".kl_reviews__star_rating_widget");
    console.log("review_div", review_div);
    review_div.addEventListener("click", function () {
      //console.log('Clicked element:', elements);
      var productInfoContainer = document.querySelector(
        ".product__info-container"
      );
      console.log("Product Info Container:", productInfoContainer);
      var dataUrl = productInfoContainer.getAttribute("data-url");
      //console.log('Data URL:', "https://dairypill.com/"+dataUrl);
      if (dataUrl) {
        window.location.href = dataUrl + "#fulfilled-reviews-all";
      }
    });
  }

  // Call the function after a delay
  setTimeout(delayedClickBinding, 3000);
}

// Function to hide specific options
// function hideOptions() {
//   console.log("started")
//   var selectElement = document.getElementById('rtx-dropdown');
//   var options = selectElement.options;
//   setTimeout(()=>{
//     for (var i = options.length - 1; i >= 0; i--) {
//       var value = options[i].value;

//       // Keep the selected option and specific values to show
//       if (// Options to hide for 1 month variants
//         value === "689326293285" ||
//         value === "689326358821" ||
//         value === "689326457125" ||
//         value === "689326391589" ||
//         value === "689326489893" ||
//         value === "689326522661" ||
//         value === "689326555429" ||
//         value === "689326588197" ||
//         value === "689326620965" ||
//         // Options to hide for 3 month variants
//         value === "689325965605" ||
//         value === "689325998373" ||
//         value === "689326031141" ||
//         value === "689326096677" ||
//         value === "689326129445" ||
//         value === "689326162213" ||
//         value === "689326194981" ||
//         value === "689326227749" ||
//         value === "689326260517" ||
//         // Options to hide for 6 month variants
//         value === "689334255909" ||
//         value === "689334321445" ||
//         value === "689334354213" ||
//         value === "689334386981" ||
//         value === "689334419749" ||
//         value === "689334452517" ||
//         value === "689334485285") {
//         selectElement.remove(i);
//         console.log('removed')
//       }
//     }
//   },2000)

//   }

// // Call the function to hide options on load or based on your event trigger
// hideOptions();

function hideOptions() {
  console.log("started");
  var selectElement = document.getElementById("rtx-dropdown");
  var options = selectElement.options;
  setTimeout(() => {
    for (var i = options.length - 1; i >= 0; i--) {
      var value = options[i].value;

      // Keep the selected option and specific values to show
      if (
        // Options to hide for 1 month variants
        value === "689326293285" ||
        value === "689326358821" ||
        value === "689326457125" ||
        value === "689326391589" ||
        value === "689326489893" ||
        value === "689326522661" ||
        value === "689326555429" ||
        value === "689326588197" ||
        value === "689326620965" ||
        // Options to hide for 3 month variants
        value === "689325965605" ||
        value === "689325998373" ||
        value === "689326031141" ||
        value === "689326096677" ||
        value === "689326129445" ||
        value === "689326162213" ||
        value === "689326194981" ||
        value === "689326227749" ||
        value === "689326260517" ||
        // Options to hide for 6 month variants
        value === "689334255909" ||
        value === "689334321445" ||
        value === "689334354213" ||
        value === "689334386981" ||
        value === "689334419749" ||
        value === "689334452517" ||
        value === "689334485285"
      ) {
        selectElement.remove(i);
        console.log("removed");
      }
    }
  }, 500);
}

// Call the function to hide options on load or based on your event trigger
hideOptions();

function handleDropdownChange() {
  var dropdown = document.getElementById("rtx-dropdown");
  if (!dropdown) return;

  var selectedIndex = dropdown.selectedIndex;
  var selectedOption = dropdown.options[selectedIndex];

  if (!selectedOption) return; // ✅ Fix: avoid crashing on invalid selection

  var selectedText = selectedOption.innerText;
  dropdown.value = selectedOption.value;
  selectedOption.setAttribute("selected", "selected");
  selectedOption.selected = true;

  console.log("Selected option text:", selectedText, selectedOption);

  if (selectedText === "Order Once") {
    console.log("The selected option is 'Order Once'.");
    var selected_variant = document.querySelectorAll(".position-two");
    for (var i = 0; i < selected_variant.length; i++) {
      var element = selected_variant[i];
      if (element.classList.contains("selected-variant-option")) {
        var order_once_price = element.getAttribute("order-once");
        var cart_btn = document.querySelector(".add-to-cart-price");
        if (cart_btn) {
          cart_btn.innerText = order_once_price;
        }
      }
    }
  }
}

var dropdown = document.getElementById("rtx-dropdown");
dropdown.addEventListener("change", handleDropdownChange);

var mobileComparisonHeaders = document.querySelectorAll(
  ".comparison-table__column-header.large-up-hide.medium-hide"
);
if (mobileComparisonHeaders) {
  mobileComparisonHeaders.forEach((mobileComparisonHeader) => {
    mobileComparisonHeader.addEventListener("click", (e) => {
      e.preventDefault();
      var thisHeaderHref = mobileComparisonHeader.getAttribute("href");
      thisHeaderHref = thisHeaderHref.replace("#", "");
      console.log("thisHeaderHref", thisHeaderHref);
      var divtoScroll = document.querySelector(
        ".comparison-table-headers.comparison-table__columns.desktop_show"
      );
      var columntoScroll = document.querySelector(
        ".comparison-table__container .comparison-table__columns"
      );
      if (columntoScroll) {
        var columnElement = columntoScroll.querySelector("." + thisHeaderHref);
        columntoScroll.scrollLeft = columnElement.offsetLeft + 500;
      }
      if (divtoScroll) {
        var toScrollElement = divtoScroll.querySelector(
          `[id=${thisHeaderHref}]`
        );
        divtoScroll.scrollLeft = toScrollElement.offsetLeft;
      }

      mobileComparisonHeaders.forEach((mobileComparisonHeaderSib) => {
        if (mobileComparisonHeaderSib != mobileComparisonHeader) {
          mobileComparisonHeaderSib.classList.remove("active");
        }
      });
      mobileComparisonHeader.classList.add("active");
    });
  });
}

// comparison table 2 tabs

// Scroll the table to a specific column when a tab button is clicked
document.querySelectorAll(".tab-btn").forEach(function (tableTab) {
  tableTab.addEventListener("click", function () {
    var dataTabColumn = parseInt(tableTab.dataset.column) - 1;
    var dataTableScroll = dataTabColumn * 140;
    var tableContainer = tableTab
      .closest(".table_div")
      .querySelector(".table-container");

    var matchingColumn = tableContainer.querySelector(
      '.tab-header-columns[data-column="' + dataTabColumn + '"]'
    );

    if (matchingColumn) {
      console.log("matchingColumn:", matchingColumn);
      console.log(
        "matchingColumn.offsetLeft:",
        matchingColumn.offsetLeft,
        dataTableScroll
      );

      // Scroll the table horizontally to the column
      if (dataTabColumn == 0) {
        tableContainer.scrollLeft = 0;
      } else {
        tableContainer.scrollLeft = dataTableScroll;
      }
    } else {
      tableContainer.scrollLeft = 0;
    }
  });
});

var oneTimePurchaseLabel = document.querySelectorAll(
  "label.rtx-subscription-label.one-time-purchase-label"
);
if (oneTimePurchaseLabel) {
  oneTimePurchaseLabel.forEach((oneTimePurcaseLabel1) => {
    oneTimePurcaseLabel1.addEventListener("click", () => {
      var subscriptionDropdown = document.querySelector("#rtx-dropdown");
      if (subscriptionDropdown) {
        subscriptionDropdownOptions =
          subscriptionDropdown.querySelectorAll("option");
        subscriptionDropdownOptions?.forEach((option) => {
          option.removeAttribute("selected");
        });
      }
      var getOneTimePrice = oneTimePurcaseLabel1.querySelector(
        "[data-rtx-onetime-price]"
      ).textContent;
      // document.querySelector('.product-form__submit .add-to-cart-price').innerHTML = getOneTimePrice;
    });
  });
}

// pdp sticky add to cart
document.addEventListener("DOMContentLoaded", function () {
  // Select all buttons with the class .product__buy--button
  var buyButtons = document.querySelectorAll(".product__buy--button");

  // Loop through each button and add the click event listener
  buyButtons.forEach(function (stickyAtcButton) {
    stickyAtcButton.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default button action if needed

      // Find the form submit button and trigger its click event
      var submitButton = document.querySelector(".product-form__submit");
      if (submitButton) {
        submitButton.click();
      } else {
        console.error(".product-form__submit not found");
      }
    });
  });
});

var stickyAtcButtonBuyNow = document.querySelector(".product__buy-now--button");
if (stickyAtcButtonBuyNow) {
  stickyAtcButtonBuyNow.addEventListener("click", (e) => {
    if (buyNowBtn) {
      if (pdpATCBtn.classList.contains("disabled")) {
        pdpATCBtn.click();
      } else {
        buyNowBtn.click();
        productAtcForm.submit();
      }
    }
  });
}

const box1 = document.querySelector(".product-form__submit");
const box2 = document.querySelector(".sticky-atc-bar");

function checkIfBox1IsInViewport() {
  if (box1 && box2) {
    const rect = box1.getBoundingClientRect();
    if (rect.top < 0) {
      box2.style.display = "block";
    } else {
      box2.style.display = "none";
    }
  }
}

window.addEventListener("scroll", checkIfBox1IsInViewport);
window.addEventListener("resize", checkIfBox1IsInViewport);

checkIfBox1IsInViewport();

// cart drawer subsriptions

document.addEventListener("click", (ev) => {
  if (ev.target.matches(".subscription_btn")) {
    var getItemId = ev.target.dataset.itemKey;
    var getItemQty = ev.target.dataset.itemQty;
    var getItemPlan = ev.target.dataset.sellingId;

    console.log(
      "Item ID:",
      getItemId,
      "Quantity:",
      getItemQty,
      "Selling Plan:",
      getItemPlan
    );
    console.log("selling plan");

    // Ensure getItemId is just the line item ID, not a combination of IDs
    // If getItemId includes the selling plan, you'll need to extract the line item ID only
    const lineItemId = getItemId.split(":")[0]; // Extract only the line item ID if needed

    // Validate the necessary fields
    if (!lineItemId || !getItemQty || !getItemPlan) {
      console.error("Missing required data");
      return;
    }

    let update = {
      id: parseInt(getItemId),
      quantity: parseInt(getItemQty, 10),
      selling_plan: parseInt(getItemPlan),
    };

    // Make the API request
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(getItemId),
            quantity: 6,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Cart updated", data);
      })
      .then((response) => {
        // if (!response.ok) {
        //   throw new Error('Network response was not ok');
        // }
        // return response.text();
      })
      .then((pageHTML) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(pageHTML, "text/html");
        const updatedCartDrawer = doc.querySelector("#CartDrawer");
        const currentCartDrawer = document.querySelector("#CartDrawer");

        if (currentCartDrawer && updatedCartDrawer) {
          currentCartDrawer.innerHTML = updatedCartDrawer.innerHTML;
          startCountdown(remainingTime);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
});

var variantLabels = document.querySelectorAll(".selected-variant-label");
if (variantLabels) {
  variantLabels.forEach((variantLabel) => {
    variantLabel.addEventListener("click", function () {
      var dataValue = variantLabel.previousElementSibling.getAttribute("value");
      if (document.querySelector(".form__label.supply_label")) {
        document
          .querySelector(".form__label.supply_label")
          .querySelector("strong").textContent = dataValue;
      }
    });
  });
}

// Instead of attaching event listener to a single button, attach it to the parent container
document.addEventListener("click", function (event) {
  // Check if the clicked element is a button inside the .noxu-cart-upsell container
  if (
    event.target.closest(".noxu-cart-upsell") &&
    event.target.classList.contains("upsell__toggle-switch")
  ) {
    // Select the parent container for the upsell toggle
    var cartUpsellParent = event.target.closest(".noxu-cart-upsell");
    var cartUpsellToggle = event.target;

    // Show loading spinner
    cartUpsellToggle
      .querySelector(".loading-overlay__spinner")
      .classList.remove("hidden");

    // Add a background with white opacity to the button
    cartUpsellToggle.style.opacity = "0.5"; // white with 50% opacity
    cartUpsellToggle.style.pointerEvents = "none"; // Disable button click until the action is complete

    var upsellParentToggle = cartUpsellParent.dataset.checked;
    var upsellProductId = cartUpsellParent.dataset.variantId;

    console.log("upsellProductId", upsellProductId);
    const isShipCartUpsell = true;
    const lineItemProperties = {};
    if (isShipCartUpsell) {
      lineItemProperties["is_shipping_upsell"] = isShipCartUpsell; // Set the property name and value
    }

    // Handle the case of adding to cart (if upsellProductId is not yet added)
    if (upsellParentToggle == "false") {
      cartUpsellParent.setAttribute("data-checked", "true");

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: upsellProductId,
              quantity: 1,
              properties: lineItemProperties,
            },
          ],
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Product added to cart:", data);

          // Hide the loading spinner once product is added
          cartUpsellToggle
            .querySelector(".loading-overlay__spinner")
            .classList.add("hidden");
          cartUpsellToggle.textContent = "Added"; // Update button text to 'Added'

          // Remove the white background opacity from the button
          cartUpsellToggle.style.opacity = ""; // Reset to original background color
          cartUpsellToggle.style.pointerEvents = ""; // Re-enable button click

          // Fetch updated cart HTML
          return fetch("/cart");
        })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.text();
        })
        .then((pageHTML) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(pageHTML, "text/html");
          const updatedCartDrawer = doc.querySelector("#CartDrawer");
          const currentCartDrawer = document.querySelector("#CartDrawer");

          if (currentCartDrawer && updatedCartDrawer) {
            currentCartDrawer.innerHTML = updatedCartDrawer.innerHTML;

            // Optionally hide an upsell product after adding
            setTimeout(function () {
              var forHide = document.querySelector(".cart-upsell-product");
              if (forHide) {
                forHide.classList.add("hide_please");
              }
            }, 1000); // Wait 1 second before attempting to add the class
          }
        })
        .catch((error) => {
          console.error(
            "There was a problem adding the product to the cart:",
            error
          );

          // Hide the spinner in case of error
          cartUpsellToggle
            .querySelector(".loading-overlay__spinner")
            .classList.add("hidden");

          // Remove the white background opacity from the button in case of error
          cartUpsellToggle.style.opacity = ""; // Reset to original background color
          cartUpsellToggle.style.pointerEvents = ""; // Re-enable button click
        });
    } else {
      // Handle the case of removing from cart
      cartUpsellParent.setAttribute("data-checked", "false");

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          updates: {
            [upsellProductId]: 0, // Set quantity to 0 for the specific item ID
          },
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Product removed from cart:", data);

          // Optionally, you can update the cart UI here
          // Fetch updated cart HTML after removing the item
          return fetch("/cart");
        })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.text();
        })
        .then((pageHTML) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(pageHTML, "text/html");
          const updatedCartDrawer = doc.querySelector("#CartDrawer");
          const currentCartDrawer = document.querySelector("#CartDrawer");

          if (currentCartDrawer && updatedCartDrawer) {
            currentCartDrawer.innerHTML = updatedCartDrawer.innerHTML;
          }
        })
        .catch((error) => {
          console.error(
            "There was a problem removing the product from the cart:",
            error
          );

          // Hide the spinner in case of error
          cartUpsellToggle
            .querySelector(".loading-overlay__spinner")
            .classList.add("hidden");

          // Remove the white background opacity from the button in case of error
          cartUpsellToggle.style.opacity = ""; // Reset to original background color
          cartUpsellToggle.style.pointerEvents = ""; // Re-enable button click
        });
    }
  }
});
